exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-creditcardexpiry__expiry{float:right}", ""]);

// exports
exports.locals = {
	"expiry": "nil-sa-elements-creditcardexpiry__expiry"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/CreditCardExpiry/index.less
// module id = 516
// module chunks = 0